export default __webpack_public_path__ + "static/media/newPromotionBanner.4ea4116c.jpg";